import { Http } from "@/shared/http/http";
import { AxiosResponse } from "axios";
import { TokensResp } from "@/shared/http/models/tokens.resp";

const AuthApi = (baseUrl: string) => ({
  register: `${baseUrl}/register`,
  registerConfirm: `${baseUrl}/register/confirm`,
  signPaid: `${baseUrl}/sign-in/paid`,
});

const AuthApiConnectorFactory = (baseUrl: string) => {
  const endpoints = AuthApi(baseUrl);

  const register = (email: string) => {
    return Http.post({
      url: endpoints.register,
      data: {
        email,
      },
    });
  };

  const registerConfirm = async (data: {
    email: string;
    code: string;
    type_id: number;
  }): Promise<AxiosResponse<TokensResp>> => {
    return Http.post({
      url: endpoints.registerConfirm,
      data: {
        email: data.email,
        code: data.code,
        type_id: data.type_id,
        role_id: 2,
      },
    });
  };

  const signAfterPaid = async (data: {
    sessionId: string;
    type: string;
  }): Promise<AxiosResponse<TokensResp>> => {
    return Http.post({
      url: `${endpoints.signPaid}?session_id=${data.sessionId}&type=${data.type}`,
    });
  };

  return {
    register,
    registerConfirm,
    signAfterPaid,
  };
};

const baseUrl = "";

export const AuthApiConnector = AuthApiConnectorFactory(baseUrl);
